import ResultService from '@/services/ResultService'

const state = () => ({
  menu: [],
  sports: [],
  liveresults: []
})

const getters = {}

const actions = {
  async GET_MENU ({ commit }, date) {
    try {
      const response = await ResultService.menu({ date: date })
      commit('SET_MENU', response.data)
    } catch (error) {
      console.log(error.response.data.error)
    }
  },
  async GET_OVERVIEW ({ commit }, { date, sport = null }) {
    let params = { date: date }
    if (sport) {
      params.sport = sport
    }
    try {
      const response = await ResultService.overview(params)
      commit('SET_OVERVIEW', response.data)
    } catch (error) {
      console.log(error.response.data.error)
    }
  },
  async GET_LIVERESULTS ({ commit }, { params }) {
    try {
      const response = await ResultService.liveresults(params)
      commit('SET_LIVERESULTS', response.data)
    } catch (error) {
      console.log(error.response.data.error)
    }
  }
}

const mutations = {
  CLEAR (state) {
    state.menu = []
    state.sports = []
  },
  SET_MENU (state, data) {
    state.menu = data.sports.map(sport => { return Object.assign({}, sport) })
  },
  SET_OVERVIEW (state, data) {
    state.sports = data.sports.map(sport => { return Object.assign({}, sport) })
  },
  SET_LIVERESULTS (state, data) {
    state.liveresults = data.sports.map(sport => { return Object.assign({}, sport) })
  }
}

export default {
  namespaced: true,
  mutations,
  getters,
  actions,
  state
}



// WEBPACK FOOTER //
// ./src/store/modules/results.js